import * as React from "react";

function Workflow(props) {
  return (
    <svg width={21} height={20} fill="none" {...props}>
      <path
        d="M17.008 7a3 3 0 00-2.82 2h-5.18V4h1.18a3 3 0 100-2h-2.18a1 1 0 00-1 1v6h-1.18a3 3 0 100 2h1.18v6a1 1 0 001 1h2.18a3 3 0 100-2h-1.18v-5h5.18a3 3 0 102.82-4zm-4-5a1 1 0 110 2 1 1 0 010-2zm-10 9a1 1 0 110-2 1 1 0 010 2zm10 5a1 1 0 110 2.002 1 1 0 010-2.002zm4-5a1 1 0 110-1.999 1 1 0 010 1.999z"
        stroke="none"
        fill="currentColor"
      />
    </svg>
  );
}

const WorkflowIcon = React.memo(Workflow);
export default WorkflowIcon;
